module.exports = __webpack_public_path__ + "static/media/content.ccc3632c.svg";